module.exports = __webpack_public_path__ + "img/portugal.a4fb2394.png";